import { useQuery } from '@tanstack/react-query';

import { LojaProps } from '../types';

import { useApplicationContext } from 'context/ApplicationContext';
import { useClientContext } from 'context/ClientContext';
import { useListagemContext } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { FilterValuesProps } from 'hooks/useFilter';
import { useRequestListagem } from 'hooks/useRequestListagem';
import { Totalizador } from 'pages/compra/pedido/types';

export function useQueryTotalizador() {
    const requestListagem = useRequestListagem();
    const { formattedStore } = useApplicationContext();
    const { hasPermission } = usePermissionsContext();
    const hasPermissionFinalizacaoGeral = hasPermission(['COMPRA_PEDIDO_FINALIZACAO_GERAL']);
    const { tipoPedido } = useClientContext();
    const isTipoPedidoFuncionario = tipoPedido === 'funcionario';
    const { autoLoad, getFilterValues } = useListagemContext();
    const { idLoja: lojas = [], idUsuario: funcionario } = getFilterValues();
    const hasLojas = Boolean(lojas.length);
    const filter: FilterValuesProps[] = [];

    if (hasLojas) {
        filter.push({ property: 'idLoja', operator: 'in', value: lojas.map((loja: LojaProps) => loja.idLoja) });
    }

    if (isTipoPedidoFuncionario && formattedStore) {
        filter.push({ property: 'idLoja', operator: 'in', value: [formattedStore.idLoja] });
    }

    if (isTipoPedidoFuncionario && funcionario) {
        filter.push({ property: 'idUsuarioPedido', operator: 'eq', value: funcionario.idUsuario });
    }

    return useQuery<Totalizador>({
        cacheTime: 0,
        enabled: hasLojas || (isTipoPedidoFuncionario && !hasPermissionFinalizacaoGeral) || autoLoad,
        queryKey: ['carrinho-totalizador', lojas, formattedStore, funcionario],
        queryFn: () =>
            requestListagem({
                url: '/compra/pedidovltotalwrapper/rascunho',
                sort: [{ property: 'vlTotal', direction: 'ASC' }],
                filter,
            }).then((res) => res.data),
    });
}
